// define the SKUs which should render a STVO image
export const skusIncludingStvo = ['3111', '3112', '3113', '3114']

// category ID for Frame colors
export const categoryFrameColorsId = 263
export const categoryLogoColorsId = 291
